import { useCallback } from 'react'

import { Button } from '@/components/ui/button.tsx'
import { Dialog } from '@/components/ui/dialog.tsx'
import { useToast } from '@/components/ui/toast'
import { useMassMessageMutations } from '@/modules/online-mass-messages/hooks/use-mass-message-mutations'

import { DialogProps } from '../types'

interface Props extends DialogProps {
  messageId: number
}

export const StopOmmDialog = ({ isOpen, onClose, messageId }: Props) => {
  const { updateMutation } = useMassMessageMutations()
  const toast = useToast()

  const handleConfirm = useCallback(async () => {
    await updateMutation.mutateAsync({
      messageId,
      values: {
        status: 'Cancelled',
      },
    })
    toast.success('Successfully stopped Mass Message')
    onClose()
  }, [onClose, updateMutation, messageId, toast])

  return (
    <Dialog
      show={isOpen}
      onClose={onClose}
    >
      <Dialog.Header>
        <Dialog.Title className="text-center">Stop Sending</Dialog.Title>
        <Dialog.Description className="text-center">
          Are you sure that you want to stop sending these mass messages?
        </Dialog.Description>
      </Dialog.Header>

      <Dialog.ClosableFooter onClose={onClose}>
        <Button
          variant="destructive"
          type="button"
          onClick={handleConfirm}
          isLoading={updateMutation.isLoading}
        >
          Stop
        </Button>
      </Dialog.ClosableFooter>
    </Dialog>
  )
}
